@for (periodData of periodPrices; track periodData) {
  <div class="mkt-table">
    <div class="mkt-table-row">
      <div class="mkt-table-col main-hdr" align="left">
        <span class="main-hdr-text">{{ periodData.name }}</span>
        <button
          type="button"
          class="right icon-button main-hdr-expand-button"
          (click)="toggle('period', periodData.name)">
          @if (getEnabledFlag('period', periodData.name)) {
            <i class="fa fa-angle-down"></i>
          }
          @if (!getEnabledFlag('period', periodData.name)) {
            <i class="fa fa-angle-right"></i>
          }
        </button>
      </div>
    </div>
    @if (getEnabledFlag('period', periodData.name)) {
      @for (group of periodData.periodGroup; track group) {
        <div class="mkt-table-row">
          <!-- teams header -->
          <div class="mkt-table-col teams team-col" align="left">
            <div class="mkt-table">
              <div class="mkt-table-row">
                <div class="mkt-table-col cat-hdr" align="left">
                  {{ group.name }}
                  <button type="button" class="icon-button team-expand-button" (click)="toggle('group', group.name)">
                    @if (getEnabledFlag('group', group.name)) {
                      <i class="fa fa-angle-down"></i>
                    }
                    @if (!getEnabledFlag('group', group.name)) {
                      <i class="fa fa-angle-right"></i>
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
          @if (getEnabledFlag('group', group.name)) {
            <!-- moneyline header -->
            <div class="mkt-table-col moneyline" align="center">
              <div class="mkt-table">
                <div class="mkt-table-row">
                  <div class="mkt-table-col hdr-text hdr-odds" align="center">1</div>
                  <div class="mkt-table-col hdr-text hdr-odds" align="center">X</div>
                  <div class="mkt-table-col hdr-text hdr-odds" align="center">2</div>
                </div>
              </div>
            </div>
            <!-- handicap header -->
            <div class="mkt-table-col handicap" align="center">
              <div class="mkt-table">
                <div class="mkt-table-row">
                  <div class="mkt-table-col hdr-text hdr-handicap" align="center">Handicap</div>
                </div>
              </div>
            </div>
            <!-- totals header -->
            <div class="mkt-table-col totals" align="center">
              <div class="mkt-table">
                <div class="mkt-table-row">
                  <div class="mkt-table-col hdr-text hdr-odds" align="center">Over</div>
                  <div class="mkt-table-col hdr-text hdr-odds" align="center">Under</div>
                  <div class="mkt-table-col hdr-text hdr-more-markets" align="center">&nbsp;</div>
                </div>
              </div>
            </div>
          }
        </div>
        @if (getEnabledFlag('group', group.name)) {
          @for (event of group.eventPrices; track event) {
            <div class="mkt-table-row">
              <!-- teams -->
              <div class="mkt-table-col teams-data team-col" align="left">
                <div class="mkt-table">
                  <div class="mkt-table-row">
                    <div class="mkt-table-col team-text" align="left">{{ event.homeTeam }}</div>
                    <div class="mkt-table-col score small-text" align="right">{{ event.homeScore }}</div>
                  </div>
                  <div class="mkt-table-row">
                    <div class="mkt-table-col team-text" align="left">{{ event.awayTeam }}</div>
                    <div class="mkt-table-col score-text" align="right">{{ event.awayScore }}</div>
                  </div>
                  <div class="mkt-table-row">
                    <div class="mkt-table-col period-text" align="left">{{ event.playStatus }}</div>
                  </div>
                </div>
              </div>
              <!-- moneyline -->
              @if (hasMoneyLine(event)) {
                <div class="mkt-table-col moneyline" align="center">
                  <div class="mkt-table">
                    @for (marketPrice of event.markets | marketSort: 'MONEY_LINE' : 'ONE'; track marketPrice) {
                      <div class="mkt-table-row">
                        <div class="mkt-table-col" align="center">
                          <button type="button" class="odds">
                            <odds
                              [showSign]="true"
                              [odds]="marketPrice.home ? marketPrice.home.odds : undefined"></odds>
                          </button>
                        </div>
                        <div class="mkt-table-col" align="center">
                          <odds [showSign]="true" [odds]="marketPrice.draw ? marketPrice.draw.odds : undefined"></odds>
                        </div>
                        <div class="mkt-table-col" align="center">
                          <odds [showSign]="true" [odds]="marketPrice.away ? marketPrice.away.odds : undefined"></odds>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              } @else {
                <div class="mkt-table-col moneyline" align="center">
                  <div class="mkt-table">
                    <div class="mkt-table-row">
                      <div class="mkt-table-col" align="center">
                        <button type="button" class="odds">
                          <odds></odds>
                        </button>
                      </div>
                      <div class="mkt-table-col" align="center">
                        <button type="button" class="odds">
                          <odds></odds>
                        </button>
                      </div>
                      <div class="mkt-table-col" align="center">
                        <button type="button" class="odds">
                          <odds></odds>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <!-- handicap -->
              @if (!hasHandicap(event)) {
                <div class="mkt-table-col handicap" align="center">
                  <div class="mkt-table">
                    @for (marketPrice of event.markets | marketSort: 'HANDICAP' : 'ONE'; track marketPrice) {
                      <div class="mkt-table-row">
                        <div class="mkt-table-col" align="center">
                          <button type="button" class="odds">
                            <div class="spread">
                              <odds
                                [showSign]="true"
                                [name]="marketPrice.home ? marketPrice.home.name : ''"
                                [odds]="marketPrice.home ? marketPrice.home.odds : undefined"></odds>
                            </div>
                          </button>
                        </div>
                        <div class="mkt-table-col" align="center">
                          <button type="button" class="odds">
                            <!--                                            <div class="spread">-1</div>-->
                            <!--                                            <div>+116</div>-->
                            <odds
                              [showSign]="true"
                              [name]="marketPrice.away ? marketPrice.away.name : ''"
                              [odds]="marketPrice.away ? marketPrice.away.odds : undefined"></odds>
                          </button>
                        </div>
                        <div class="mkt-table-col space-right" align="center">
                          <button type="button" class="icon-button expand-button">
                            <i class="fa fa-angle-double-down"></i>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              } @else {
                <div class="mkt-table-col handicap" align="center">
                  <div class="mkt-table">
                    <div class="mkt-table-row">
                      <div class="mkt-table-col" align="center">
                        <button type="button" class="odds">
                          <div class="spread">
                            <odds></odds>
                          </div>
                        </button>
                      </div>
                      <div class="mkt-table-col" align="center">
                        <button type="button" class="odds">
                          <div class="spread">
                            <odds></odds>
                          </div>
                        </button>
                      </div>
                      <div class="mkt-table-col space-right" align="center">
                        <button type="button" class="icon-button expand-button">&nbsp;&nbsp;</button>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <!-- totals -->
              @if (!hasTotals(event)) {
                <div class="mkt-table-col totals" align="center">
                  <div class="mkt-table">
                    @for (marketPrice of event.markets | marketSort: 'TOTAL' : 'ONE'; track marketPrice) {
                      <div class="mkt-table-row">
                        <div class="mkt-table-col" align="center">
                          <button type="button" class="odds">
                            <div class="spread">+1</div>
                            <div>-131</div>
                          </button>
                        </div>
                        <div class="mkt-table-col" align="center">
                          <button type="button" class="odds">
                            <div class="spread">+1</div>
                            <div>-131</div>
                          </button>
                        </div>
                        <div class="mkt-table-col" align="center">
                          <button type="button" class="icon-button expand-button">
                            <i class="fa fa-angle-double-down"></i>
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              } @else {
                <div class="mkt-table-col totals" align="center">
                  <div class="mkt-table">
                    <div class="mkt-table-row">
                      <div class="mkt-table-col" align="center">
                        <button type="button" class="odds">
                          <div class="spread">
                            <odds></odds>
                          </div>
                        </button>
                      </div>
                      <div class="mkt-table-col" align="center">
                        <button type="button" class="odds">
                          <div class="spread">
                            <odds></odds>
                          </div>
                        </button>
                      </div>
                      <div class="mkt-table-col" align="center">
                        <button type="button" class="icon-button expand-button">&nbsp;&nbsp;</button>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <!-- more markets -->
              @if (hasMoreMarkets(event)) {
                <div class="mkt-table-col totals" align="center">
                  <div class="mkt-table">
                    <div class="mkt-table-row">
                      <div class="mkt-table-col" align="right">
                        <button type="button" class="icon-button more-markets-icon-button">
                          <span class="number-markets">+10 <i class="fa fa-angle-right"></i></span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              } @else {
                <div class="mkt-table-col totals" align="center">
                  <div class="mkt-table">
                    <div class="mkt-table-row">
                      <div class="mkt-table-col" align="right">
                        <button type="button" class="icon-button more-markets-icon-button">
                          <span class="number-markets">&nbsp;</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
            <div class="event-divider"></div>
          }
        }
      }
    }
    <div class="mkt-table">
      <div class="mkt-table-row">
        <div class="mkt-table-col main-hdr" align="left">
          <span class="main-hdr-text">Tomorrow</span>
          <button type="button" class="right icon-button main-hdr-expand-button">
            <i class="fa fa-angle-down"></i>
          </button>
        </div>
      </div>
      <div class="mkt-table-row">
        <!-- teams header -->
        <div class="mkt-table-col teams team-col" align="left">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col hdr-text" align="left">
                England - Premier league
                <button type="button" class="icon-button team-expand-button">
                  <i class="fa fa-angle-down"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- moneyline header -->
        <div class="mkt-table-col moneyline" align="center">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col hdr-text hdr-odds" align="center">1</div>
              <div class="mkt-table-col hdr-text hdr-odds" align="center">X</div>
              <div class="mkt-table-col hdr-text hdr-odds" align="center">2</div>
            </div>
          </div>
        </div>
        <!-- handicap header -->
        <div class="mkt-table-col handicap" align="center">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col hdr-text hdr-handicap" align="center">Handicap</div>
            </div>
          </div>
        </div>
        <!-- totals header -->
        <div class="mkt-table-col totals" align="center">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col hdr-text hdr-odds" align="center">Over</div>
              <div class="mkt-table-col hdr-text hdr-odds" align="center">Under</div>
              <div class="mkt-table-col hdr-text hdr-more-markets" align="center">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
      <div class="mkt-table-row">
        <!-- teams -->
        <div class="mkt-table-col teams-data team-col" align="left">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col team-text" align="left">Chelsea</div>
              <div class="mkt-table-col score small-text" align="right">0</div>
            </div>
            <div class="mkt-table-row">
              <div class="mkt-table-col team-text" align="left">Liverpool</div>
              <div class="mkt-table-col score-text" align="right">2</div>
            </div>
            <div class="mkt-table-row">
              <div class="mkt-table-col period-text" align="left">First Half - 31'</div>
            </div>
          </div>
        </div>
        <!-- moneyline -->
        <div class="mkt-table-col moneyline" align="center">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">+257</button>
              </div>
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">+249</button>
              </div>
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">+106</button>
              </div>
            </div>
          </div>
        </div>
        <!-- handicap -->
        <div class="mkt-table-col handicap" align="center">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">
                  <div class="spread">+1</div>
                  <div>-131</div>
                </button>
              </div>
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">
                  <div class="spread">-1</div>
                  <div>+116</div>
                </button>
              </div>
              <div class="mkt-table-col space-right" align="center">
                <button type="button" class="icon-button expand-button">
                  <i class="fa fa-angle-double-down"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- totals -->
        <div class="mkt-table-col totals" align="center">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">
                  <div class="spread">+1</div>
                  <div>-131</div>
                </button>
              </div>
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">
                  <div class="spread">+1</div>
                  <div>-131</div>
                </button>
              </div>
              <div class="mkt-table-col" align="center">
                <button type="button" class="icon-button expand-button">
                  <i class="fa fa-angle-double-down"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- more markets -->
        <div class="mkt-table-col totals" align="center">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col" align="right">
                <button type="button" class="icon-button more-markets-icon-button">
                  <span class="number-markets">+10 <i class="fa fa-angle-right"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="expanded-container">
        <!-- expand money-line - match -->
        <div class="mkt-table-row handicap">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col sub-hdr" align="left">
                <span class="sub-hdr-text">Moneyline - Match</span>
                <button type="button" class="right icon-button sub-hdr-expand-button">
                  <i class="fa fa-angle-down"></i>
                </button>
              </div>
            </div>
            <div class="mkt-table-row">
              <div class="mkt-table-col">
                <button type="button" class="odds two-odds extended">
                  <div class="left">Chelsea</div>
                  <div class="right">-749</div>
                </button>
              </div>
              <div class="mkt-table-col">
                <button type="button" class="odds two-odds extended">
                  <div class="left">Liverpool</div>
                  <div class="right">-749</div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- expand money-line - period -->
        <div class="mkt-table-row handicap">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col sub-hdr" align="left">
                <span class="sub-hdr-text">Moneyline - First Half</span>
                <button type="button" class="right icon-button sub-hdr-expand-button">
                  <i class="fa fa-angle-down"></i>
                </button>
              </div>
            </div>
            <div class="mkt-table-row">
              <div class="mkt-table-col">
                <button type="button" class="odds three-odds extended">
                  <div class="left">Chelsea</div>
                  <div class="right">-749</div>
                </button>
              </div>
              <div class="mkt-table-col">
                <button type="button" class="odds three-odds extended">
                  <div class="left">Draw</div>
                  <div class="right">-749</div>
                </button>
              </div>
              <div class="mkt-table-col">
                <button type="button" class="odds three-odds extended">
                  <div class="left">Liverpool</div>
                  <div class="right">-749</div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- expand handicap - match -->
        <div class="mkt-table-row handicap">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col sub-hdr" align="left">
                <span class="sub-hdr-text">Handicap - Match</span>
                <button type="button" class="right icon-button sub-hdr-expand-button">
                  <i class="fa fa-angle-down"></i>
                </button>
              </div>
            </div>
            <div class="mkt-table-row">
              <div class="mkt-table-col hdr-text two-odds extended" align="center">Chelsea</div>
              <div class="mkt-table-col hdr-text two-odds extended" align="center">Liverpool</div>
            </div>
            <div class="mkt-table-row">
              <div class="mkt-table-col">
                <button type="button" class="odds two-odds extended">
                  <div class="left">+2.5</div>
                  <div class="right">+749</div>
                </button>
              </div>
              <div class="mkt-table-col">
                <button type="button" class="odds two-odds extended">
                  <div class="left">-2.5</div>
                  <div class="right">-749</div>
                </button>
              </div>
            </div>
            <!-- another row -->
            <div class="mkt-table-row">
              <div class="mkt-table-col">
                <button type="button" class="odds two-odds extended">
                  <div class="left">+2.0</div>
                  <div class="right">+749</div>
                </button>
              </div>
              <div class="mkt-table-col">
                <button type="button" class="odds two-odds extended">
                  <div class="left">-2.0</div>
                  <div class="right">-749</div>
                </button>
              </div>
            </div>
          </div>
          <!-- expand handicap - first half -->
          <div class="mkt-table-row handicap">
            <div class="mkt-table">
              <div class="mkt-table-row">
                <div class="mkt-table-col sub-hdr" align="left">
                  <span class="sub-hdr-text">Handicap - First Half</span>
                  <button type="button" class="right icon-button sub-hdr-expand-button">
                    <i class="fa fa-angle-down"></i>
                  </button>
                </div>
              </div>
              <div class="mkt-table-row">
                <div class="mkt-table-col hdr-text two-odds extended" align="center">Chelsea</div>
                <div class="mkt-table-col hdr-text two-odds extended" align="center">Liverpool</div>
              </div>
              <div class="mkt-table-row">
                <div class="mkt-table-col">
                  <button type="button" class="odds two-odds extended">
                    <div class="left">+2.5</div>
                    <div class="right">-749</div>
                  </button>
                </div>
                <div class="mkt-table-col">
                  <button type="button" class="odds two-odds extended">
                    <div class="left">-2.5</div>
                    <div class="right">+749</div>
                  </button>
                </div>
              </div>
              <!-- another row -->
              <div class="mkt-table-row">
                <div class="mkt-table-col">
                  <button type="button" class="odds two-odds extended">
                    <div class="left">+2.5</div>
                    <div class="right">-749</div>
                  </button>
                </div>
                <div class="mkt-table-col">
                  <button type="button" class="odds two-odds extended">
                    <div class="left">-2.5</div>
                    <div class="right">+749</div>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- row 2 -->
      <div class="mkt-table-row">
        <!-- teams -->
        <div class="mkt-table-col teams-data team-col" align="left">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col team-text" align="left">Chelsea</div>
              <div class="mkt-table-col score small-text" align="right">0</div>
            </div>
            <div class="mkt-table-row">
              <div class="mkt-table-col team-text" align="left">Liverpool</div>
              <div class="mkt-table-col score-text" align="right">2</div>
            </div>
            <div class="mkt-table-row">
              <div class="mkt-table-col period-text" align="left">First Half - 31'</div>
            </div>
          </div>
        </div>
        <!-- moneyline -->
        <div class="mkt-table-col moneyline" align="center">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">+257</button>
              </div>
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">+249</button>
              </div>
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">+106</button>
              </div>
            </div>
          </div>
        </div>
        <!-- handicap -->
        <div class="mkt-table-col handicap" align="center">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">-131</button>
              </div>
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">+116</button>
              </div>
              <div class="mkt-table-col space-right" align="center">
                <button type="button" class="icon-button expand-button">
                  <i class="fa fa-angle-double-down"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- totals -->
        <div class="mkt-table-col totals" align="center">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">-103</button>
              </div>
              <div class="mkt-table-col" align="center">
                <button type="button" class="odds">+116</button>
              </div>
              <div class="mkt-table-col" align="center">
                <button type="button" class="icon-button expand-button">
                  <i class="fa fa-angle-double-down"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- more markets -->
        <div class="mkt-table-col totals" align="center">
          <div class="mkt-table">
            <div class="mkt-table-row">
              <div class="mkt-table-col" align="right">
                <button type="button" class="icon-button more-markets-icon-button">
                  <span class="number-markets">+10 <i class="fa fa-angle-right"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
